import * as React from "react";
import { ResponsiveFilterButtonProps } from "../types";

import images from "./assets/images";

const ResponsiveFilterButton: React.FC<ResponsiveFilterButtonProps> = ({
  selectedFilters,
  filterOptions,
  toggleFilter,
  clearAllFilters,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div className="relative md:hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-grayBack text-sm text-white font-ubuntu px-4 py-2 rounded-md shadow-md flex items-center"
      >
        <img
          src={images.filterIcon} // Replace with actual filter icon path
          alt="Filter icon"
          className="w-[22px] h-[19px] mr-2"
        />
        Filters
        {selectedFilters.length > 0 && (
          <span className="font-ubunt absolute top-0 right-0 -mt-2 -mr-2 bg-primary text-white text-xs rounded-full w-5 h-5 flex items-center justify-center border-2 border-white">
            {selectedFilters.length}
          </span>
        )}
      </button>

      {isOpen && (
        <div className="absolute z-10 mt-2 w-64 bg-white rounded-md shadow-lg">
          <div className="p-2">
            {filterOptions.map((option) => (
              <button
                key={option.id}
                onClick={() => toggleFilter(option.id)}
                className={`w-full text-left p-2 rounded ${
                  selectedFilters.includes(option.id) ? "bg-gray-200" : ""
                }`}
              >
                {option.name}
              </button>
            ))}
          </div>
          <div className="border-t p-2">
            <button
              onClick={clearAllFilters}
              className="w-full text-center text-sm text-gray-600"
            >
              Clear All Filters
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ResponsiveFilterButton;
